angular
  .module('capability-ng-scheduler')
  .service(
    'deleteStudentAvailabilityCommand',
    function deleteStudentAvailabilityCommandDefinition(defineCommand, $http) {
      return defineCommand(
        'deleteStudentAvailabilityCommand',
        function deleteStudentAvailabilityCommand(deferred, termId, timeId) {
          if (!termId || !timeId) {
            deferred.resolve();
            return;
          }

          $http
            .delete('reg/preference/term/' + termId + '/availability/' + timeId)
            .then(function (response) {
              deferred.resolve(response.data);
            })
            .catch(function (e) {
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/student_availability/commands/delete_student_availability_command.js